import { FEATURE_FLAGS } from "src/constants/FeatureFlag";

export const AppScreens = {
    QUOTES: "Quotes Screen",
    NOTICEBOARD: "Noticeboard Screen",
    BODY_AND_MIND: "Body & Mind Screen",
    PLAYLISTS: "Playlists Screen",
    GOALS: "Goals Screen",
    HABITS: "Habits Screen"
};

export const featureToPermissionIdMap = {
    QUOTES: FEATURE_FLAGS.QUOTES,
    NOTICEBOARD: FEATURE_FLAGS.NOTICEBOARD,
    BODY_AND_MIND: FEATURE_FLAGS.BODY_AND_MIND,
    PLAYLISTS: FEATURE_FLAGS.PLAYLISTS,
    GOALS: FEATURE_FLAGS.GOAL_TRACKER,
    HABITS: FEATURE_FLAGS.HABIT_TRACKER
};

export const screenFeatureMap = {
    [AppScreens.QUOTES]: "QUOTES",
    [AppScreens.NOTICEBOARD]: "NOTICEBOARD",
    [AppScreens.BODY_AND_MIND]: "BODY_AND_MIND",
    [AppScreens.PLAYLISTS]: "PLAYLISTS",
    [AppScreens.GOALS]: "GOALS",
    [AppScreens.HABITS]: "HABITS"
};

export const getAvailableScreens = (flags = []) => {
    return Object.values(AppScreens).filter((screen) => {
        const feature = screenFeatureMap[screen];
        const flag = featureToPermissionIdMap[feature];

        if (!flag) return false;

        return flags.includes(flag);
    });
};

export const getDefaultStartScreen = (flags = []) => {
    const screens = getAvailableScreens(flags);
    return screens.length > 0 ? screens[0] : null;
};
